'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('DataService', function() {
  function getCustomDatePickerClass(datePickerDate, allDates) {
    let customClass = '';
    const mode = datePickerDate.mode;
    const date = datePickerDate.date;

    if (mode === 'day' && allDates.datas.indexOf(moment(date).format('Y-MM-DD')) >= 0) {
      customClass = 'day-with-operation';
    } else if (mode === 'month' && allDates.meses.indexOf(moment(date).format('Y-MM')) >= 0) {
      customClass = 'day-with-operation';
    } else if (mode === 'year' && allDates.anos.indexOf(moment(date).format('Y')) >= 0) {
      customClass = 'day-with-operation';
    }

    return customClass;
  }

  return {
    getMinData: function(data, novaData) {
      return moment(data).isBefore(moment(novaData)) ? data : novaData;
    },

    getMaxData: function(data, novaData) {
      return moment(data).isAfter(moment(novaData)) ? data : novaData;
    },

    getDatePickerCustomClass: (datePickerDate, allDates) => {
      if (!allDates || !datePickerDate) {
        return '';
      }

      return getCustomDatePickerClass(datePickerDate, allDates);
    }
  };
});
